var CollectionView = require('views/base/collection-view');

var ResourceView = CollectionView.extend({
  noWrap: true,
  autoRender: false,
  template: require('./templates/resource'),
  listSelector: '.resource-items',
  itemView: require('./resource-item-view'),
  animationDuration: 0,
  initialize: function() {
    this.collection = EF.resources;
    EF.resources.fetch();
    CollectionView.prototype.initialize.apply(this, arguments);
  },
  getTemplateData: Chaplin.View.prototype.getTemplateData
});

module.exports = ResourceView;